<div *ngIf="item">
  <div [class.active]="isActive" class="d-flex flex-row">
    <div>
      <a class="play" *ngIf="!isActive" href="javascript:;" (click)="play()">
        <i class="fa fa-play" aria-hidden="true"></i>
      </a>
      <span class="playing" *ngIf="isActive">
        <i class="fa fa-play" aria-hidden="true"></i>
      </span>
      {{item.playable ? item.playable.name : item.media.url}}

      <span class="actions" *ngIf="item.subitems && item.subitems.length > 0">
        <a href="javascript:;" (click)="remove()">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </a>
      </span>
    </div>
    <div class="spacer"></div>
    <div>
      <a class="order" href="javascript:;" *ngIf="topLevel">
        <i class="fa fa-sort" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="details">
    <div class="summary">
      <div *ngIf="item.playable && item.playable.summary">
        {{item.playable.summary}}
      </div>
      <div *ngIf="item.playable && !item.playable.summary && item.playable.description">
        {{item.playable.description}}
      </div>
    </div>
    <div class="actions" *ngIf="!item.subitems || item.subitems.length == 0">
      <a href="javascript:;" (click)="remove()">
        <i class="fa fa-trash" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <div class="subitems" *ngIf="item.subitems">
    <queue-item *ngFor="let subitem of item.subitems" [item]="subitem" [activeItem]="activeItem"></queue-item>
  </div>
</div>